export default __webpack_public_path__ + "static/media/aut2.51159ebc.jpeg";